import httpClient from '../http.client';
import gloading from '../../utils/gloading';

export default function () {
  httpClient.interceptors.request.use(
    (config) => {
      if (config.showLoader) {
        gloading.show(config.nameLoader);
      }
      return config;
    },
    (error) => {
      const { config } = error || {};
      if (config && config.showLoader) {
        gloading.hide(config.nameLoader);
      }
      return error;
    }
  );

  httpClient.interceptors.response.use(
    (response) => {
      const { config } = response || {};
      if (config.showLoader) {
        gloading.hide(config.nameLoader);
      }
      return Promise.resolve(response);
    },
    (error) => {
      const { response = {} } = error || {};
      const { config = {} } = response;

      if (!response.status) {
        // em caso de erro de internet o response vem vazio
        gloading.stop();
      } else if (config.showLoader) {
        gloading.hide(config.nameLoader);
      }
      return Promise.reject(error);
    }
  );
}
